import { collection, get, query, where } from "typesaurus"

export interface Set {
  id: string
  name: string
  displayName?: string
  navCategory?: string
  navName?: string
  nodeTag?: string
  content?: {
    [key: string]: {
      active: boolean
      index: number
    }
  }
  contentType: string
  directions?: string
  maxNodeLevels?: number | string
  maxRaw?: number | string
  setType?: string
  testType?: string
  timeLimit?: number | string
  template?: string
  subjectTemplate?: string
  sectionBreaks?: string[]
  rawToScaleScoring?: {
    [key: string]: string | number
  }
  // rawToScaleScoring?: number[]  // different Type
  researchSummaryPassages?: string[]
  gradeLevels?: string[]
  conflictingViewpointsPassages?: string[]
  dataRepresentationPassages?: string[]
  precisionQuestions?: string[]
  precisionComparables?: string[]
  timeManagementEasy?: string[]
  timeManagementHard?: string[]
  licensable?: boolean
  deleted?: boolean
  type?: string
  setId: string
  groupName?: string
  testCategory?: string
  bubbleSheet?: boolean
  isGrouped?: boolean
  index?: number
  externalTestLink?: string
  bubbleSheetSubtest?: boolean
  chapterPageHidden?: boolean // not used
  createdDate?: number // not used
  lastModifiedDate?: number // not used
  source?: string // not used
  subTestGid?: string // not used
  subtestTemplate?: string // not used
}

export interface DestructuredSubtests {
  [key: string]: { items: string[] }
}

export interface AssessmentSet {
  assessmentSet: Set
  assessmentSubtests: Record<string, Set>
  destructuredSubtests: DestructuredSubtests
}

const collection_ref = collection<Set>("sets")

export const getSetById = (id: string) => {
  return get(collection_ref, id)
}

export const getSetByLicensable = (value = true) => {
  return query(collection_ref, [where("licensable", "==", value)])
}
